<template>
    <v-dialog v-model="show_dialog" ref="save_event_dialog" scrollable persistent max-width="600px" :fullscreen="$vuetify.breakpoint.smAndDown">
        <v-form ref="saveEventForm" method="post" :action="form.action" v-model="form.valid" v-on:success="success_save_event">
            <v-card>
                <v-card-title
                        class="headline blue darken-2 white--text"
                        primary-title
                >
                    <div v-if="is_new_item">{{$t('event.create_event')}}</div>
                    <div v-else>{{$t('event.edit_event')}}</div>
                </v-card-title>
                <v-card-text ref="scrollContainer" id="scrollContainer" class="v-dialog-body">
                    <input type="hidden" name="is_new_item" :value="is_new_item?1:0">
                    <input type="hidden" name="event_id" v-model="form.data.event_id">
                    <input type="hidden" name="event_start" v-model="form.data.start_date_string">
                    <input type="hidden" name="event_end" v-model="form.data.end_date_string">
                    <input type="hidden" name="enroll_start" v-model="form.data.enrollment_start_date">
                    <input type="hidden" name="enroll_end" v-model="form.data.enrollment_end_date">
                    <input type="hidden" name="location_lat" v-model="form.data.location_lat">
                    <input type="hidden" name="location_lng" v-model="form.data.location_lng">
                    <input type="hidden" name="cover_file_id" v-model="form.data.cover_file_id">
                    <input type="hidden" name="removed_activity" v-model="form.data.removed_activity">

                    <v-container grid-list-md>
                        <v-layout wrap>

                            <v-flex xs12 v-show="form.errors.general!==''">
                                <v-alert
                                        ref="general"
                                        :value="form.errors.general!==''"
                                        type="error"
                                >
                                    {{form.errors.general}}
                                </v-alert>
                            </v-flex>

                            <h2>
                                {{$t('event.general_setting')}}
                                <v-tooltip bottom>
                                    <v-icon slot="activator" dark color="grey darken-1" @click.stop="">info</v-icon>
                                    <span>{{$t('event.setting_desc.general_setting')}}</span>
                                </v-tooltip>
                            </h2>

                            <v-flex xs12>
                                <v-text-field
                                        :label="$t('event.title')"
                                        v-model="form.data.event_title"
                                        :error-messages="form.errors.title"
                                        ref="title"
                                        name="title"
                                >
                                </v-text-field>
                            </v-flex>
                            <v-flex xs7 sm4>
                                <v-menu
                                        ref="start_date_wp"
                                        :close-on-content-click="false"
                                        v-model="start_date_wp"
                                        :nudge-right="40"
                                        :return-value.sync="start_date"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        min-width="290px"
                                >
                                    <v-text-field
                                            slot="activator"
                                            v-model="start_date"
                                            :value="format_date(start_date)"
                                            :label="$t('event.start_time')"
                                            :rules="[rules.required]"
                                            :error-messages="form.errors.event_start"
                                            readonly
                                    ></v-text-field>
                                    <v-date-picker
                                            v-model="start_date"
                                            @input="$refs.start_date_wp.save(start_date); updated_start_date(); start_date_wp = false;"
                                    ></v-date-picker>
                                </v-menu>
                            </v-flex>

                            <v-flex xs5 sm2>
                                <v-dialog
                                        ref="start_time_wp"
                                        v-model="start_time_wp"
                                        :return-value.sync="start_time"
                                        persistent
                                        lazy
                                        full-width
                                        width="290px"
                                >
                                    <v-text-field
                                            slot="activator"
                                            :value="format_time(start_time)"
                                            :rules="[rules.required]"
                                            readonly
                                    ></v-text-field>
                                    <v-time-picker
                                            v-if="start_time_wp"
                                            v-model="start_time"
                                            full-width
                                    >
                                        <v-spacer></v-spacer>
                                        <v-btn flat color="primary" @click="start_time_wp = false">{{$t('action.cancel')}}</v-btn>
                                        <v-btn flat color="primary" @click="$refs.start_time_wp.save(start_time);updated_start_date();">{{$t('action.ok')}}</v-btn>
                                    </v-time-picker>
                                </v-dialog>
                            </v-flex>

                            <v-flex xs7 sm4>
                                <v-menu
                                        ref="end_date_wp"
                                        :close-on-content-click="false"
                                        v-model="end_date_wp"
                                        :nudge-right="40"
                                        :return-value.sync="end_date"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        min-width="290px"
                                >
                                    <v-text-field
                                            slot="activator"
                                            v-model="end_date"
                                            :value="format_date(end_date)"
                                            :label="$t('event.end_time')"
                                            :error-messages="form.errors.event_end"
                                            :rules="[rules.required]"
                                            readonly
                                    ></v-text-field>
                                    <v-date-picker
                                            v-model="end_date"
                                            @input="$refs.end_date_wp.save(end_date); end_date_wp = false;"
                                    ></v-date-picker>

                                </v-menu>
                            </v-flex>

                            <v-flex xs5 sm2>
                                <v-dialog
                                        ref="end_time_wp"
                                        v-model="end_time_wp"
                                        :return-value.sync="end_time"
                                        persistent
                                        lazy
                                        full-width
                                        width="290px"
                                >
                                    <v-text-field
                                            slot="activator"
                                            :value="format_time(end_time)"
                                            :rules="[rules.required]"
                                            readonly
                                    ></v-text-field>
                                    <v-time-picker
                                            v-if="end_time_wp"
                                            v-model="end_time"
                                            full-width
                                    >
                                        <v-spacer></v-spacer>
                                        <v-btn flat color="primary" @click="end_time_wp = false">{{$t('action.cancel')}}</v-btn>
                                        <v-btn flat color="primary" @click="$refs.end_time_wp.save(end_time)">{{$t('action.ok')}}</v-btn>
                                    </v-time-picker>
                                </v-dialog>
                            </v-flex>

                            <v-flex xs12>
                                <v-switch
                                        v-model="form.data.enable_for_enrollment"
                                        name="enable_for_enrollment"
                                        class="mt-0 mb-3"
                                        color="indigo"
                                        :label="form.data.enable_for_enrollment ? $t('event.enrollment_open') : $t('event.enrollment_close')"
                                        :value="1"
                                        hide-details
                                ></v-switch>
                            </v-flex>

                            <template v-if="form.data.enable_for_enrollment">
                                <v-flex xs12>
                                    <v-switch
                                            v-model="form.data.enable_enrollment_time"
                                            name="enable_enrollment_time"
                                            class="mt-0 mb-3"
                                            color="indigo"
                                            :label="$t('event.enable_enrollment_time')"
                                            :value="1"
                                            hide-details
                                    ></v-switch>
                                </v-flex>

                                <v-flex xs7 sm4 v-if="form.data.enable_enrollment_time">
                                    <v-menu
                                            ref="enroll_start_date_wp"
                                            :close-on-content-click="false"
                                            v-model="enroll_start_date_wp"
                                            :nudge-right="40"
                                            :return-value.sync="enroll_start_date"
                                            lazy
                                            transition="scale-transition"
                                            offset-y
                                            full-width
                                            min-width="290px"
                                    >
                                        <v-text-field
                                                slot="activator"
                                                v-model="enroll_start_date"
                                                :value="format_date(enroll_start_date)"
                                                :label="$t('event.enroll_start_time')"
                                                :rules="[rules.required]"
                                                :error-messages="form.errors.enroll_start"
                                                readonly
                                        ></v-text-field>
                                        <v-date-picker
                                                v-model="enroll_start_date"
                                                @input="$refs.enroll_start_date_wp.save(enroll_start_date); update_form_enroll_start_time(); enroll_start_date_wp = false;"
                                        ></v-date-picker>
                                    </v-menu>
                                </v-flex>

                                <v-flex xs5 sm2 v-if="form.data.enable_enrollment_time">
                                    <v-dialog
                                            ref="enroll_start_time_wp"
                                            v-model="enroll_start_time_wp"
                                            :return-value.sync="enroll_start_time"
                                            persistent
                                            lazy
                                            full-width
                                            width="290px"
                                    >
                                        <v-text-field
                                                slot="activator"
                                                :value="format_time(enroll_start_time)"
                                                :rules="[rules.required]"
                                                readonly
                                        ></v-text-field>
                                        <v-time-picker
                                                v-if="enroll_start_time_wp"
                                                v-model="enroll_start_time"
                                                full-width
                                        >
                                            <v-spacer></v-spacer>
                                            <v-btn flat color="primary" @click="enroll_start_time_wp = false">{{$t('action.cancel')}}</v-btn>
                                            <v-btn flat color="primary" @click="$refs.enroll_start_time_wp.save(enroll_start_time);update_form_enroll_start_time();">{{$t('action.ok')}}</v-btn>
                                        </v-time-picker>
                                    </v-dialog>
                                </v-flex>

                                <v-flex xs7 sm4 v-if="form.data.enable_enrollment_time">
                                    <v-menu
                                            ref="enroll_end_date_wp"
                                            :close-on-content-click="false"
                                            v-model="enroll_end_date_wp"
                                            :nudge-right="40"
                                            :return-value.sync="enroll_end_date"
                                            lazy
                                            transition="scale-transition"
                                            offset-y
                                            full-width
                                            min-width="290px"
                                    >
                                        <v-text-field
                                                slot="activator"
                                                v-model="enroll_end_date"
                                                :value="format_date(enroll_end_date)"
                                                :label="$t('event.enroll_end_time')"
                                                :error-messages="form.errors.enroll_end"
                                                :rules="[rules.required]"
                                                readonly
                                        ></v-text-field>
                                        <v-date-picker
                                                v-model="enroll_end_date"
                                                @input="$refs.enroll_end_date_wp.save(enroll_end_date); enroll_end_date_wp = false;"
                                        ></v-date-picker>

                                    </v-menu>
                                </v-flex>

                                <v-flex xs5 sm2 v-if="form.data.enable_enrollment_time">
                                    <v-dialog
                                            ref="enroll_end_time_wp"
                                            v-model="enroll_end_time_wp"
                                            :return-value.sync="enroll_end_time"
                                            persistent
                                            lazy
                                            full-width
                                            width="290px"
                                    >
                                        <v-text-field
                                                slot="activator"
                                                :value="format_time(enroll_end_time)"
                                                :rules="[rules.required]"
                                                readonly
                                        ></v-text-field>
                                        <v-time-picker
                                                v-if="enroll_end_time_wp"
                                                v-model="enroll_end_time"
                                                full-width
                                        >
                                            <v-spacer></v-spacer>
                                            <v-btn flat color="primary" @click="enroll_end_time_wp = false">{{$t('action.cancel')}}</v-btn>
                                            <v-btn flat color="primary" @click="$refs.enroll_end_time_wp.save(enroll_end_time)">{{$t('action.ok')}}</v-btn>
                                        </v-time-picker>
                                    </v-dialog>
                                </v-flex>
                            </template>



                            <v-flex xs12>
                                <v-text-field
                                        :label="$t('event.location')"
                                        ref="autocomplete"
                                        name="location_text"
                                        v-model="form.data.location_text"
                                        v-on:keydown.enter.prevent
                                        v-on:keydown.exact="clear_location($event)"
                                >
                                </v-text-field>
                            </v-flex>
                            <v-flex sm12 class="mb-3" v-show="form.data.location_lat && form.data.location_lng">
                                <GmapMap ref="mapRef"
                                         :center="gmap_center"
                                         :zoom="gmap_zoom"
                                         style="width: 100%; height: 200px"
                                >
                                    <GmapMarker
                                            v-if="gmap_center"
                                            :position="gmap_center"
                                    ></GmapMarker>
                                </GmapMap>
                            </v-flex>

                            <v-flex xs12 class="mb-3">
                                <label class="v-label sp-v-label">{{$t('event.cover_photo')}}</label>
                                <v-card v-if="cover_file" class="elevation-0">
                                    <v-img
                                            :src="cover_file.absolute_url"
                                            aspect-ratio="2"
                                            class="lighten-2 elevation-1"
                                            style="max-width: 200px"
                                            contain
                                    >
                                    </v-img>
                                    <v-btn small color="error" class="ml-0" @click="remove_cover_file">{{$t('action.remove')}}</v-btn>
                                </v-card>
                                <v-card v-else class="upload-image-wp elevation-0 text-xs-center" @click="show_upload_event_img_dialog" v-bind:style="hover_image_upload ? 'border: 3px dashed #AAA' : 'border: 3px dashed #DDD'" @mouseover="hover_image_upload = true" @mouseleave="hover_image_upload = false">
                                    <v-card-title class="justify-center pb-0">
                                        <v-icon size="40">fas fa-cloud-upload-alt</v-icon>
                                    </v-card-title>
                                    <v-card-text class="">
                                        {{$t('event.msg_select_an_event_image')}}
                                    </v-card-text>
                                </v-card>
                            </v-flex>


                            <v-flex xs12>
                                <v-expansion-panel>
                                    <v-expansion-panel-content>
                                        <h2 slot="header">
                                            {{$t('event.more_event_info')}}
                                            <v-tooltip bottom>
                                                <v-icon slot="activator" dark color="grey darken-1" @click.stop="">info</v-icon>
                                                <span>{{$t('event.setting_desc.more_event_info')}}</span>
                                            </v-tooltip>
                                        </h2>
                                        <v-card>
                                            <v-card-text>
                                                <v-flex xs12 class="mb-3">
                                                    <label class="v-label sp-v-label">{{$t('event.event_images')}}</label>
                                                    <div class="event-images-wrapper">
                                                        <div class="elevation-1" v-if="form.data.event_photos.length">
                                                            <v-list>
                                                                <template v-for="(event_photo, index) in form.data.event_photos">
                                                                    <input type="hidden" :name="'event_photo_id[' + index + ']'" v-model="event_photo.id">
                                                                    <input type="hidden" :name="'event_photo_file[' + index + ']'" v-model="event_photo.file.id">
                                                                    <input type="hidden" :name="'event_photo_description[' + index + ']'" v-model="event_photo.description">
                                                                    <v-list-tile
                                                                            avatar
                                                                    >
                                                                        <v-list-tile-avatar>
                                                                            <v-img class="event-image-preview" :src="event_photo.file.absolute_url"></v-img>
                                                                        </v-list-tile-avatar>

                                                                        <v-list-tile-content>
                                                                            <v-list-tile-title class="event-attachment-desc">{{event_photo.file.filename}}</v-list-tile-title>
                                                                            <v-list-tile-sub-title class="event-attachment-subtitle">{{event_photo.description}}</v-list-tile-sub-title>
                                                                        </v-list-tile-content>

                                                                        <v-list-tile-action>
                                                                            <v-menu
                                                                                    transition="scale-transition"
                                                                                    bottom
                                                                                    left>
                                                                                <v-btn
                                                                                        slot="activator"
                                                                                        icon>
                                                                                    <v-icon>more_vert</v-icon>
                                                                                </v-btn>
                                                                                <v-list>
                                                                                    <v-list-tile @click="edit_event_attachment(event_photo)"><v-icon class="pr-1 fa-fw">edit</v-icon>{{$t('action.edit')}}</v-list-tile>
                                                                                    <v-list-tile @click="remove_event_photo(index)"><v-icon class="pr-1 fa-fw">delete</v-icon>{{$t('action.remove')}}</v-list-tile>
                                                                                </v-list>
                                                                            </v-menu>
                                                                        </v-list-tile-action>
                                                                    </v-list-tile>
                                                                </template>
                                                            </v-list>
                                                        </div>
                                                        <div class="empty-item-wrapper" v-else>
                                                            {{$t('event.no_event_image')}}
                                                        </div>
                                                    </div>
                                                    <v-btn small color="green" dark class="ml-0" @click="show_upload_event_photo_dialog">{{$t('action.add')}}</v-btn>

                                                </v-flex>

                                                <v-flex xs12 class="mb-3">
                                                    <label class="v-label sp-v-label">{{$t('event.event_attachments')}}</label>
                                                    <div class="event-images-wrapper">
                                                        <div class="elevation-1" v-if="form.data.event_attachments.length">
                                                            <v-list>
                                                                <template v-for="(event_attachment, index) in form.data.event_attachments">
                                                                    <input type="hidden" :name="'event_attachment_id[' + index + ']'" v-model="event_attachment.id">
                                                                    <input type="hidden" :name="'event_attachment_file[' + index + ']'" v-model="event_attachment.file.id">
                                                                    <input type="hidden" :name="'event_attachment_description[' + index + ']'" v-model="event_attachment.description">
                                                                    <v-list-tile
                                                                            avatar
                                                                    >
                                                                        <v-list-tile-avatar>
                                                                            <v-icon>{{get_file_icon_class(event_attachment.file.filename)}}</v-icon>
                                                                        </v-list-tile-avatar>

                                                                        <v-list-tile-content>
                                                                            <v-list-tile-title class="event-attachment-desc"><a :href="event_attachment.file.absolute_url" target="_blank">{{event_attachment.file.filename}}</a></v-list-tile-title>
                                                                            <v-list-tile-sub-title class="event-attachment-subtitle">{{event_attachment.description}}</v-list-tile-sub-title>
                                                                        </v-list-tile-content>

                                                                        <v-list-tile-action>
                                                                            <v-menu
                                                                                    transition="scale-transition"
                                                                                    bottom
                                                                                    left>
                                                                                <v-btn
                                                                                        slot="activator"
                                                                                        icon>
                                                                                    <v-icon>more_vert</v-icon>
                                                                                </v-btn>
                                                                                <v-list>
                                                                                    <v-list-tile @click="edit_event_attachment(event_attachment)"><v-icon class="pr-1 fa-fw">edit</v-icon>{{$t('action.edit')}}</v-list-tile>
                                                                                    <v-list-tile @click="remove_event_attachment(index)"><v-icon class="pr-1 fa-fw">delete</v-icon>{{$t('action.remove')}}</v-list-tile>
                                                                                </v-list>
                                                                            </v-menu>
                                                                        </v-list-tile-action>
                                                                    </v-list-tile>
                                                                </template>
                                                            </v-list>
                                                        </div>
                                                        <div class="empty-item-wrapper" v-else>
                                                            {{$t('event.no_event_attachment')}}
                                                        </div>
                                                    </div>
                                                    <v-btn small color="green" dark class="ml-0" @click="show_upload_event_attachment_dialog">{{$t('action.add')}}</v-btn>

                                                </v-flex>

                                                <v-flex xs12 class="mb-3">
                                                    <label class="v-label sp-v-label">
                                                        {{$t('event.description')}}
                                                    </label>
                                                    <textarea class="hidden-textarea" name="description"
                                                              v-model="form.data.event_description"/>
                                                    <quill-editor v-model="form.data.event_description" id="quill-editor"
                                                                  ref="myQuillEditor"
                                                                  :options="editorOption"
                                                    >
                                                    </quill-editor>
                                                </v-flex>

                                                <!--<v-flex xs12>-->
                                                <!--<v-radio-group-->
                                                <!--row-->
                                                <!--mandatory-->
                                                <!--name="is_private"-->
                                                <!--v-model="form.data.is_private"-->
                                                <!--:disabled="form.data.event_id > 0"-->
                                                <!--&gt;-->
                                                <!--<v-radio key="0" :label="$t('event.public')" :value="0"></v-radio>-->
                                                <!--<v-radio key="1" :label="$t('event.private')" :value="1"></v-radio>-->
                                                <!--</v-radio-group>-->
                                                <!--</v-flex>-->
                                            </v-card-text>
                                        </v-card>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-flex>

                            <v-flex xs12>
                                <v-expansion-panel>
                                    <v-expansion-panel-content>
                                        <h2 slot="header">
                                            {{$t('event.advanced_setting')}}
                                            <v-tooltip bottom>
                                                <v-icon slot="activator" dark color="grey darken-1" @click.stop="">info</v-icon>
                                                <span>{{$t('event.setting_desc.advance_setting')}}</span>
                                            </v-tooltip>
                                        </h2>
                                        <v-card>
                                            <v-card-text>
                                                <v-checkbox
                                                        v-model="form.data.ask_for_attend"
                                                        name="ask_for_attend"
                                                        class="mt-0 mb-3"
                                                        color="indigo"
                                                        :label="$t('event.ask_for_attend')"
                                                        :value="1"
                                                        hide-details
                                                />

                                                <v-checkbox
                                                        v-model="form.data.enable_select_name_from_invitations"
                                                        name="enable_select_name_from_invitations"
                                                        class="mt-0 mb-3"
                                                        color="indigo"
                                                        :label="$t('event.enable_select_name_from_invitations')"
                                                        :value="1"
                                                        hide-details
                                                />

                                                <v-checkbox
                                                        v-model="form.data.allow_invited_contact_only"
                                                        name="allow_invited_contact_only"
                                                        class="mt-0 mb-3"
                                                        color="indigo"
                                                        :label="$t('event.allow_invited_contact_only')"
                                                        :value="1"
                                                        hide-details
                                                />

                                                <v-checkbox
                                                        v-model="form.data.allow_guest_to_join"
                                                        name="allow_guest_to_join"
                                                        class="mt-0 mb-3"
                                                        color="indigo"
                                                        :label="$t('event.allow_guest_to_join')"
                                                        :value="1"
                                                        hide-details
                                                />

                                                <v-checkbox
                                                        v-model="form.data.allow_retrieve_registration"
                                                        name="allow_retrieve_registration"
                                                        class="mt-0 mb-3"
                                                        color="indigo"
                                                        :label="$t('event.allow_retrieve_registration')"
                                                        :value="1"
                                                        hide-details
                                                ></v-checkbox>

                                                <v-checkbox
                                                        v-model="form.data.enable_registration_notify"
                                                        name="enable_registration_notify"
                                                        class="mt-0 mb-3"
                                                        color="indigo"
                                                        :label="$t('event.enable_registration_notify')"
                                                        :value="1"
                                                        hide-details
                                                />

                                                <v-text-field
                                                        :label="$t('event.quota')"
                                                        v-model="form.data.quota"
                                                        name="quota"
                                                        :hint="$t('event.quota_desc')"
                                                />

                                                <h2 class="my-4">
                                                    {{$t('event.payment_related')}}
                                                    <v-tooltip bottom>
                                                        <v-icon slot="activator" dark color="grey darken-1" @click.stop="">info</v-icon>
                                                        <span>{{$t('event.setting_desc.payment_related')}}</span>
                                                    </v-tooltip>
                                                </h2>

                                                <v-text-field
                                                        :label="$t('event.price_per_head')"
                                                        prefix="$"
                                                        v-model="form.data.price_per_head"
                                                        :error-messages="form.errors.price_per_head"
                                                        name="price_per_head"
                                                        :hint="$t('event.price_per_head_usage')"
                                                        persistent-hint
                                                >
                                                </v-text-field>

                                                <v-checkbox
                                                        v-model="form.data.enable_submit_payment"
                                                        name="enable_submit_payment"
                                                        class="mb-3"
                                                        color="indigo"
                                                        :label="$t('event.enable_submit_payment')"
                                                        :value="1"
                                                        hide-details
                                                ></v-checkbox>

                                                <v-checkbox
                                                        v-model="form.data.payment_receipt_mandatory"
                                                        name="payment_receipt_mandatory"
                                                        class="mb-3"
                                                        color="indigo"
                                                        :label="$t('event.payment_receipt_mandatory')"
                                                        :disabled="!form.data.enable_submit_payment"
                                                        :value="1"
                                                        hide-details
                                                ></v-checkbox>

                                                <h2 class="my-4">
                                                    {{$t('event.custom_field')}}
                                                    <v-tooltip bottom>
                                                        <v-icon slot="activator" dark color="grey darken-1" @click.stop="">info</v-icon>
                                                        <span>{{$t('event.setting_desc.custom_field')}}</span>
                                                    </v-tooltip>
                                                </h2>

                                                <v-checkbox
                                                        v-model="form.data.enable_custom_field"
                                                        name="enable_custom_field"
                                                        class="mt-0 mb-3"
                                                        color="indigo"
                                                        :label="$t('event.enable_custom_field')"
                                                        :value="1"
                                                        hide-details
                                                ></v-checkbox>

                                                <div v-if="form.data.enable_custom_field">
                                                    <v-text-field
                                                            :label="$t('event.custom_field_label')"
                                                            v-model="form.data.custom_field_label"
                                                            name="custom_field_label"
                                                    >
                                                    </v-text-field>
                                                </div>

                                                <v-checkbox
                                                        v-model="form.data.enable_custom_field_2"
                                                        name="enable_custom_field_2"
                                                        class="mt-0 mb-3"
                                                        color="indigo"
                                                        :label="$t('event.enable_custom_field') + '2'"
                                                        :value="1"
                                                        hide-details
                                                ></v-checkbox>

                                                <div v-if="form.data.enable_custom_field_2">
                                                    <v-text-field
                                                            :label="$t('event.custom_field_label')"
                                                            v-model="form.data.custom_field_label_2"
                                                            name="custom_field_label_2"
                                                    >
                                                    </v-text-field>
                                                </div>

                                                <v-checkbox
                                                        v-model="form.data.enable_custom_field_3"
                                                        name="enable_custom_field_3"
                                                        class="mt-0 mb-3"
                                                        color="indigo"
                                                        :label="$t('event.enable_custom_field') + '3'"
                                                        :value="1"
                                                        hide-details
                                                ></v-checkbox>

                                                <div v-if="form.data.enable_custom_field_3">
                                                    <v-text-field
                                                            :label="$t('event.custom_field_label')"
                                                            v-model="form.data.custom_field_label_3"
                                                            name="custom_field_label_3"
                                                    >
                                                    </v-text-field>
                                                </div>

                                                <h2 class="my-4">
                                                    {{$t('event.activity_setting')}}
                                                    <v-tooltip bottom>
                                                        <v-icon slot="activator" dark color="grey darken-1" @click.stop="">info</v-icon>
                                                        <span>{{$t('event.setting_desc.activity_setting')}}</span>
                                                    </v-tooltip>
                                                </h2>
                                                <v-checkbox
                                                        v-model="form.data.activity_mandatory"
                                                        name="activity_mandatory"
                                                        class="mt-0 mb-3"
                                                        color="indigo"
                                                        :label="$t('event.activity_mandatory')"
                                                        :value="1"
                                                        hide-details
                                                ></v-checkbox>

                                                <v-checkbox
                                                        v-model="form.data.activity_multiple"
                                                        name="activity_multiple"
                                                        class="mt-0 mb-3"
                                                        color="indigo"
                                                        :label="$t('event.activity_multiple')"
                                                        :value="1"
                                                        hide-details
                                                ></v-checkbox>

                                                <div class="activity-wrapper">
                                                    <div class="elevation-1" v-if="form.data.activities.length">
                                                        <v-list>
                                                            <template v-for="(activity_item, index) in form.data.activities">
                                                                <input type="hidden" :name="'activity_id[' + index + ']'" v-model="activity_item.id">
                                                                <input type="hidden" :name="'activity_name[' + index+ ']'" v-model="activity_item.name">
                                                                <input type="hidden" :name="'activity_quota[' + index + ']'" v-model="activity_item.quota">
                                                                <v-list-tile>
                                                                    <v-list-tile-content>
                                                                        <v-list-tile-title>{{activity_item.name}}</v-list-tile-title>
                                                                        <v-list-tile-sub-title>{{$t('event.activity_quota')}}: <template v-if="activity_item.quota">{{activity_item.quota}}</template><template v-else>{{$t('general.unlimited')}}</template></v-list-tile-sub-title>
                                                                    </v-list-tile-content>
                                                                    <v-list-tile-action>
                                                                        <v-menu
                                                                                transition="scale-transition"
                                                                                bottom
                                                                                left
                                                                        >
                                                                            <v-btn
                                                                                    slot="activator"
                                                                                    icon
                                                                            >
                                                                                <v-icon>more_vert</v-icon>
                                                                            </v-btn>
                                                                            <v-list>
                                                                                <v-list-tile @click="edit_activity(activity_item)"><v-icon class="pr-1 fa-fw">edit</v-icon>{{$t('action.edit')}}</v-list-tile>
                                                                                <v-list-tile @click="remove_activity(index)"><v-icon class="pr-1 fa-fw">delete</v-icon>{{$t('action.remove')}}</v-list-tile>
                                                                            </v-list>
                                                                        </v-menu>
                                                                    </v-list-tile-action>
                                                                </v-list-tile>
                                                            </template>
                                                        </v-list>
                                                    </div>
                                                    <div class="empty-item-wrapper" v-else>
                                                        {{$t('event.no_activity')}}
                                                    </div>

                                                    <v-btn small color="green" dark class="ml-0" @click="edit_activity()">{{$t('action.add')}}</v-btn>
                                                </div>

                                                <h2 class="my-4">
                                                    {{$t('event.registration_page')}}
                                                    <v-tooltip bottom>
                                                        <v-icon slot="activator" dark color="grey darken-1" @click.stop="">info</v-icon>
                                                        <span>{{$t('event.setting_desc.registration_page')}}</span>
                                                    </v-tooltip>
                                                </h2>
                                                <!--                            <v-flex xs12>-->
                                                <!--                                <v-checkbox-->
                                                <!--                                        v-model="form.data.display_attendee_count"-->
                                                <!--                                        name="display_attendee_count"-->
                                                <!--                                        class="mt-0 mb-3"-->
                                                <!--                                        color="indigo"-->
                                                <!--                                        :label="$t('event.display_attendee_count')"-->
                                                <!--                                        :value="1"-->
                                                <!--                                        hide-details-->
                                                <!--                                ></v-checkbox>-->
                                                <!--                            </v-flex>-->

                                                <v-checkbox
                                                        v-model="form.data.display_media"
                                                        name="display_media"
                                                        class="mt-0 mb-3"
                                                        color="indigo"
                                                        :label="$t('event.display_media')"
                                                        :value="1"
                                                        hide-details
                                                ></v-checkbox>

                                                <v-checkbox
                                                        v-model="form.data.display_registrants"
                                                        name="display_registrants"
                                                        class="mt-0 mb-3"
                                                        color="indigo"
                                                        :label="$t('event.display_registrants')"
                                                        :value="1"
                                                        hide-details
                                                ></v-checkbox>

                                                <v-checkbox
                                                        v-model="form.data.display_payment_status"
                                                        name="display_payment_status"
                                                        class="mt-0 mb-3"
                                                        color="indigo"
                                                        :label="$t('event.display_payment_status')"
                                                        :disabled="!form.data.display_registrants"
                                                        :value="1"
                                                        hide-details
                                                ></v-checkbox>

                                                <v-checkbox
                                                        v-model="form.data.display_selected_activity"
                                                        name="display_selected_activity"
                                                        class="mt-0 mb-3"
                                                        color="indigo"
                                                        :label="$t('event.display_selected_activity')"
                                                        :disabled="!form.data.display_registrants"
                                                        :value="1"
                                                        hide-details
                                                ></v-checkbox>

                                            </v-card-text>
                                        </v-card>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-flex>




                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="close_dialog">{{$t('action.close')}}</v-btn>
                    <v-btn color="blue darken-1" flat type="submit" :loading="form.loading">{{$t('action.save')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>

        <upload-dialog
                v-model="uploadDialog.show"
                :title="$t('upload.button')"
                accept="image/*"
                :maxSizeInMB="uploadDialog.maxSizeInMB"
                :type="uploadDialog.type"
                :multiple="uploadDialog.multiple"
                ref="uploadDialog"
                @success="uploadDialog.uploadSuccess"
        >
        </upload-dialog>

        <upload-dialog
                v-model="uploadEventPhotoDialog.show"
                :title="$t('upload.button')"
                accept="image/*"
                :maxSizeInMB="uploadEventPhotoDialog.maxSizeInMB"
                :type="uploadEventPhotoDialog.type"
                :multiple="uploadEventPhotoDialog.multiple"
                ref="uploadEventPhotoDialog"
                @success="uploadEventPhotoDialog.uploadSuccess"
        ></upload-dialog>

        <upload-dialog
                v-model="uploadEventAttachmentDialog.show"
                :title="$t('upload.button')"
                accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.zip,.rar"
                :maxSizeInMB="uploadEventAttachmentDialog.maxSizeInMB"
                :type="uploadEventAttachmentDialog.type"
                :multiple="uploadEventAttachmentDialog.multiple"
                ref="uploadEventAttachmentDialog"
                @success="uploadEventAttachmentDialog.uploadSuccess"
        ></upload-dialog>

        <v-dialog
                v-model="editActivityDialog.show"
                persistent
                max-width="600"
        >
            <v-card>
                <v-card-title
                        class="headline blue darken-2 white--text"
                        primary-title
                >
                    {{$t('event.edit_activity')}}
                </v-card-title>

                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-text-field
                                        :label="$t('event.activity_name')"
                                        v-model="editActivityDialog.input_data.name"
                                        :rules="[rules.required]"
                                />
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                        :label="$t('event.activity_quota')"
                                        v-model="editActivityDialog.input_data.quota"
                                        :hint="$t('event.quota_desc')"
                                        persistent-hint
                                        type="number"
                                        clearable
                                />
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer />
                    <v-btn
                            color="blue darken-1"
                            flat
                            @click="editActivityDialog.show = false"
                    >{{$t('action.close')}}</v-btn>

                    <v-btn
                            color="blue darken-1"
                            flat
                            :disabled="editActivityDialog.input_data.name == ''"
                            @click="save_activity_item"
                    >{{$t('action.ok')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
                v-model="editAttachmentDialog.show"
                persistent
                max-width="600"
        >
            <v-card>
                <v-card-title
                        class="headline blue darken-2 white--text"
                        primary-title
                >
                    Edit Description
                </v-card-title>

                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-text-field label="Description" v-model="editAttachmentDialog.input"></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="blue darken-1"
                            flat
                            @click="editAttachmentDialog.show = false"
                    >{{$t('action.close')}}</v-btn>

                    <v-btn
                            color="blue darken-1"
                            flat
                            @click="save_event_attachment_description"
                    >{{$t('action.ok')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-dialog>
</template>

<script>
    import {UrlServices} from "~/utils/url-manager";
    import FormHandling from "~/utils/data/form-handling";
    import UploadDialog from '~/components/common/UploadDialog.vue'
    import VueQuillEditor from 'vue-quill-editor';
    import Utils from '~/utils'

    export default {
        name: "SaveEventDialog",
        components: {
            UploadDialog
        },
        props: {
            show_dialog: Boolean,
            save_success_callback: Function,
            is_new_item: Boolean,
            postFields: {
                type: Boolean,
                default: false
            },
            event_item: Object
        },
        data() {
            return {
                form: {
                    form_handling_object: null,
                    action: UrlServices.createUrl({name: "api_event_update"}),
                    loading: false,
                    valid: false,
                    data: {
                        event_id: 0,
                        event_title: "",
                        event_description: "",
                        start_date_string: "",
                        end_date_string: "",
                        enrollment_start_date: "",
                        enrollment_end_date: "",
                        enable_enrollment_time: false,
                        location_text: "",
                        location_lat: "",
                        location_lng: "",
                        cover_file_id: "",
                        is_private: 0,
                        allow_invited_contact_only: 0,
                        allow_guest_to_join: 1,
                        allow_retrieve_registration: 0,
                        ask_for_attend: 0,
                        display_attendee_count: 0,
                        enable_select_name_from_invitations: 0,
                        display_media: 0,
                        display_registrants: 0,
                        display_payment_status: 0,
                        display_selected_activity: 0,
                        activities: [],
                        activity_mandatory: 0,
                        activity_multiple: 0,
                        enable_custom_field: 0,
                        enable_custom_field_2: 0,
                        enable_custom_field_3: 0,
                        enable_registration_notify: 0,
                        enable_submit_payment: 0,
                        enable_for_enrollment: 1,
                        payment_receipt_mandatory: 0,
                        custom_field_label: '',
                        custom_field_label_2: '',
                        custom_field_label_3: '',
                        price_per_head: 0,
                        quota: "",
                        event_photos: [],
                        event_attachments: [],
                        removed_activity: []
                    },
                    errors: {
                        general: "",
                        title: "",
                        event_start: "",
                        event_end: "",
                        price_per_head: "",
                    }
                },
                rules: {
                    // add (parseInt(value)===0) to allow user input zero
                    required: value => (!!value) || this.$t('form.field_required'),
                    required_allow_zero: value => (!!value || parseInt(value)===0) || this.$t('form.field_required')
                },
                start_date: null,
                start_date_wp: false,
                start_time_wp: false,
                start_time: null,
                end_date_wp: false,
                end_date: null,
                end_time_wp: false,
                end_time: null,
                enroll_start_date: null,
                enroll_start_date_wp: false,
                enroll_start_time_wp: false,
                enroll_start_time: null,
                enroll_end_date_wp: false,
                enroll_end_date: null,
                enroll_end_time_wp: false,
                enroll_end_time: null,
                cover_file: null,
                hover_image_upload: false,
                gmap_center: {
                    lat: 22,
                    lng: 114,
                },
                gmap_zoom: 11,
                editorOption: {
                    bounds: '#quill-editor',
                    modules: {
                        toolbar: {
                            container: [
                                ['bold', 'italic', 'underline', 'strike'],
                                ['link'],
                                [{ 'header': 1 }, { 'header': 2 }],
                                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                [{ 'indent': '-1' }, { 'indent': '+1' }],
                                [{ 'size': ['small', false, 'large', 'huge'] }],
                                [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                                [{ 'font': [] }],
                                [{ 'color': [] }, { 'background': [] }],
                                [{ 'align': [] }],
                            ],
                            handlers: {
                                // image: this.image_handler,
                                // link: this.link_handler
                            }
                        }
                    }
                },
                uploadDialog: {
                    show: false,
                    multiple: false,
                    uploadSuccess: function() {},
                    type: "event_img",
                    maxSizeInMB: 10
                },
                uploadEventPhotoDialog: {
                    show: false,
                    multiple: true,
                    uploadSuccess: function() {},
                    type: "event_photo",
                    maxSizeInMB: 10
                },
                uploadEventAttachmentDialog: {
                    show: false,
                    multiple: true,
                    uploadSuccess: function() {},
                    type: "event_attachment",
                    maxSizeInMB: 10
                },
                editAttachmentDialog: {
                    item: {},
                    input: "",
                    show: false
                },
                editActivityDialog: {
                    new_item: true,
                    item: {},
                    input_data: {
                        name: "",
                        quota: "",
                    },
                    show: false
                },
                default_event_duration: 7200,
                event_duration: 7200
            };
        },
        methods: {
            image_handler() {
                var range = this.$refs.myQuillEditor.quill.getSelection();
                var value = prompt('Please input the image URL');
                if(value){
                    this.$refs.myQuillEditor.quill.insertEmbed(range.index, 'image', value);
                }
            },
            link_handler(value) {
                if (value) {
                    var href = prompt(this.$t('general.msg_ask_input_url'));
                    this.$refs.myQuillEditor.quill.format('link', href);
                } else {
                    this.$refs.myQuillEditor.quill.format('link', false);
                }
            },
            format_date(date) {
                return getApp.$moment(date).format('YYYY-MM-DD');
            },
            format_time(time) {
                return getApp.$moment(time, 'HH:mm').format('hh:mm A');
            },
            update_form_start_time() {
                this.form.data.start_date_string = this.start_date + ' ' + this.start_time;
            },
            update_form_end_time() {
                this.form.data.end_date_string = this.end_date + ' ' + this.end_time;
            },
            update_form_enroll_start_time() {
                this.form.data.enrollment_start_date = this.enroll_start_date + ' ' + this.enroll_start_time;
            },
            update_form_enroll_end_time() {
                this.form.data.enrollment_end_date = this.enroll_end_date + ' ' + this.enroll_end_time;
            },
            updated_start_date() {
                let start_date_moment = getApp.$moment(this.start_date + ' ' + this.start_time, 'YYYY-MM-DD HH:mm');
                start_date_moment.add(this.event_duration, 'seconds');
                this.end_date = start_date_moment.format('YYYY-MM-DD');
                this.end_time = start_date_moment.format('HH:mm');
            },
            success_save_event(data) {
                this.save_success_callback(data);
                this.close_dialog();
            },
            close_dialog() {
                this.form.errors.general = "";
                this.$emit('update:show_dialog', false);
                this.update_event_data(this.empty_event_item);
                this.form.form_handling_object.clearErrors();
                // reset the scroll position when close the dialog
                this.$refs['scrollContainer'].scrollTop = 0;
            },
            clear_location(e) {
                if(!_.includes(['Enter', 'Space'], e.code)){
                    this.form.data.location_lat = "";
                    this.form.data.location_lng = "";
                    this.gmap_center.lat = 0;
                    this.gmap_center.lng = 0;
                }
            },
            show_upload_event_img_dialog() {
                let me = this;
                this.uploadDialog.show = true;
                this.uploadDialog.uploadSuccess = function(data) {
                    me.uploadDialog.show = false;
                    me.form.data.cover_file_id = data.result.id;
                    me.cover_file = data.result;
                };
            },
            remove_cover_file() {
                this.cover_file = null;
                this.form.data.cover_file_id = null;
            },
            show_upload_event_photo_dialog() {
                let me = this;
                this.uploadEventPhotoDialog.show = true;
                this.uploadEventPhotoDialog.uploadSuccess = function(data) {
                    me.uploadEventPhotoDialog.show = false;
                    _.each(data, function(item){
                        me.form.data.event_photos.push({
                            id: 0,
                            description: "",
                            file: item.result
                        });
                    });
                }
            },
            remove_event_photo(index) {
                this.form.data.event_photos.splice(index, 1);
            },
            edit_event_attachment(item) {
                this.editAttachmentDialog.item = item;
                this.editAttachmentDialog.input = item.description;
                this.editAttachmentDialog.show = true;
            },
            show_upload_event_attachment_dialog() {
                let me = this;
                this.uploadEventAttachmentDialog.show = true;
                this.uploadEventAttachmentDialog.uploadSuccess = function(data) {
                    me.uploadEventAttachmentDialog.show = false;
                    _.each(data, function(item){
                        me.form.data.event_attachments.push({
                            id: 0,
                            description: "",
                            file: item.result
                        });
                    });
                }
            },
            remove_event_attachment(index) {
                this.form.data.event_attachments.splice(index, 1);
            },
            save_event_attachment_description () {
                this.editAttachmentDialog.item.description = this.editAttachmentDialog.input;
                this.editAttachmentDialog.show = false;
            },
            edit_activity(item = null) {
                if(item){
                    this.editActivityDialog.new_item = false;
                    this.editActivityDialog.item = item;
                    this.editActivityDialog.input_data.name = item.name;
                    this.editActivityDialog.input_data.quota = item.quota;
                } else {
                    this.editActivityDialog.new_item = true;
                    this.editActivityDialog.item = null;
                    this.editActivityDialog.input_data.name = "";
                    this.editActivityDialog.input_data.quota = "";
                }
                this.editActivityDialog.show = true;
            },
            remove_activity(index) {
                let item_id = this.form.data.activities[index].id;
                console.log(item_id);
                if(!isNaN(item_id)){
                    this.form.data.removed_activity.push(item_id);
                }
                this.form.data.activities.splice(index, 1);
            },
            save_activity_item() {
                if(this.editActivityDialog.new_item){
                    this.form.data.activities.push({
                        id: Utils.getUniqueId(),
                        name: this.editActivityDialog.input_data.name,
                        quota: this.editActivityDialog.input_data.quota,
                    });
                } else {
                    this.editActivityDialog.item.name = this.editActivityDialog.input_data.name;
                    this.editActivityDialog.item.quota = this.editActivityDialog.input_data.quota;
                }
                this.editActivityDialog.show = false;
            },
            get_file_icon_class(type) {
                return Utils.getIconByFileName(type);
            },
            update_event_duration() {
                let start_date_moment = getApp.$moment(this.start_date + ' ' + this.start_time, 'YYYY-MM-DD HH:mm');
                let end_date_moment = getApp.$moment(this.end_date + ' ' + this.end_time, 'YYYY-MM-DD HH:mm');
                let diff_second = end_date_moment.diff(start_date_moment, 'seconds');
                if(diff_second <= 0){
                    diff_second = this.default_event_duration;
                }
                this.event_duration = diff_second;
            },
            update_event_data(new_event_item) {

                this.$refs.myQuillEditor.quill.enable(false);

                let activities = _.cloneDeep(new_event_item.activities);
                let event_photos = _.cloneDeep(new_event_item.event_photos);
                let event_attachments = _.cloneDeep(new_event_item.event_attachments);

                if(this.is_new_item){
                    _.each(event_photos, function(item){
                        item.id = 0;
                    });
                    _.each(event_attachments, function(item){
                        item.id = 0;
                    });

                    _.each(activities, function(item){
                        item.id = 0;
                    });
                }

                this.form.data = {
                    event_id: new_event_item.id,
                    event_title: new_event_item.title,
                    event_description: new_event_item.description,
                    location_text: new_event_item.location_text,
                    location_lat: parseFloat(new_event_item.location_lat),
                    location_lng: parseFloat(new_event_item.location_lng),
                    is_private: new_event_item.is_private,
                    cover_file_id: new_event_item.cover_file_id,
                    allow_invited_contact_only: new_event_item.allow_invited_contact_only,
                    allow_guest_to_join: new_event_item.allow_guest_to_join,
                    allow_retrieve_registration: new_event_item.allow_retrieve_registration,
                    ask_for_attend: new_event_item.ask_for_attend,
                    display_attendee_count: new_event_item.display_attendee_count,
                    enable_select_name_from_invitations: new_event_item.enable_select_name_from_invitations,
                    display_media: new_event_item.display_media,
                    display_registrants: new_event_item.display_registrants,
                    display_payment_status: new_event_item.display_payment_status,
                    display_selected_activity: new_event_item.display_selected_activity,
                    activities: activities,
                    activity_mandatory: new_event_item.activity_mandatory,
                    activity_multiple: new_event_item.activity_multiple,
                    enable_custom_field: new_event_item.enable_custom_field,
                    enable_custom_field_2: new_event_item.enable_custom_field_2,
                    enable_custom_field_3: new_event_item.enable_custom_field_3,
                    enable_registration_notify: new_event_item.enable_registration_notify,
                    enable_enrollment_time: new_event_item.enable_enrollment_time,
                    enable_submit_payment: new_event_item.enable_submit_payment,
                    payment_receipt_mandatory: new_event_item.payment_receipt_mandatory,
                    enable_for_enrollment: new_event_item.enable_for_enrollment,
                    custom_field_label: new_event_item.custom_field_label,
                    custom_field_label_2: new_event_item.custom_field_label_2,
                    custom_field_label_3: new_event_item.custom_field_label_3,
                    price_per_head: new_event_item.price_per_head,
                    quota: new_event_item.quota,
                    event_photos: event_photos,
                    event_attachments: event_attachments,
                    removed_activity: []
                };

                // fix the issue of quill auto focus after content change ref: https://github.com/zenoamaro/react-quill/issues/317
                this.$nextTick(function() {
                    this.$refs.myQuillEditor.quill.enable(true);
                    this.$refs.myQuillEditor.quill.blur();
                });


                if(new_event_item.location_lat){
                    this.gmap_center = {
                        lat: parseFloat(new_event_item.location_lat),
                        lng: parseFloat(new_event_item.location_lng)
                    };
                }

                this.update_form_start_time();
                this.update_form_end_time();
                this.update_form_enroll_start_time();
                this.update_form_enroll_end_time();

                this.cover_file =  new_event_item.cover_file;
                this.start_date = getApp.$moment(new_event_item.start_timestamp, 'X').format('YYYY-MM-DD');
                this.start_time = getApp.$moment(new_event_item.start_timestamp, 'X').format('HH:mm');
                this.end_date = getApp.$moment(new_event_item.end_timestamp, 'X').format('YYYY-MM-DD');
                this.end_time = getApp.$moment(new_event_item.end_timestamp, 'X').format('HH:mm');

                if(new_event_item.enable_enrollment_time){
                    this.enroll_start_date = getApp.$moment(new_event_item.enrollment_start_timestamp, 'X').format('YYYY-MM-DD');
                    this.enroll_start_time = getApp.$moment(new_event_item.enrollment_start_timestamp, 'X').format('HH:mm');
                    this.enroll_end_date = getApp.$moment(new_event_item.enrollment_end_timestamp, 'X').format('YYYY-MM-DD');
                    this.enroll_end_time = getApp.$moment(new_event_item.enrollment_end_timestamp, 'X').format('HH:mm');
                }
            }
        },
        beforeCreate() {
            this.event_duration = 7200;
            this.empty_event_item = {
                id: 0,
                title: "",
                start_timestamp: getApp.$moment().format('X'),
                end_timestamp: getApp.$moment().add(this.event_duration, 'seconds').format('X'),
                enrollment_start_timestamp: null,
                enrollment_end_timestamp: null,
                enable_enrollment_time: false,
                enable_for_enrollment: 1,
                display_media: 1,
                display_registrants: 1,
                cover_file: null,
                event_photos: [],
                event_attachments: [],
                activities: [],
                is_private: 0,
                ask_for_attend: 1,
                allow_invited_contact_only: 1,
                allow_guest_to_join: 1,
                allow_retrieve_registration: 0,
                enable_select_name_from_invitations: 1
            };
        },
        watch: {
            event_item: async function (new_event_item) {
                if(new_event_item == null){
                    this.event_duration = this.default_event_duration;
                    new_event_item = this.empty_event_item;
                    this.form.form_handling_object.formReset();
                    await this.$nextTick();     // Delay the following code so that bindings happen after the form is cleared
                }
                this.update_event_data(new_event_item);
            },
            start_date: function (){
                this.update_form_start_time();
            },
            start_time: function () {
                this.update_form_start_time();
            },
            end_date: function() {
                this.update_form_end_time();
                this.update_event_duration();
            },
            end_time: function() {
                this.update_form_end_time();
                this.update_event_duration();
            },
            enroll_start_date: function (){
                this.update_form_enroll_start_time();
            },
            enroll_start_time: function () {
                this.update_form_enroll_start_time();
            },
            enroll_end_date: function() {
                this.update_form_enroll_end_time();
            },
            enroll_end_time: function() {
                this.update_form_enroll_end_time();
            },
            show_dialog: function(val) {
                if(val){
                    let mapRef = this.$refs.mapRef;
                    //fix the render issue of google map
                    setTimeout(function(){
                        mapRef.$mapObject.setCenter(mapRef.$mapObject.getCenter());
                    }, 1500);
                } else {
                    this.form.data.enable_enrollment_time = false;
                }
            },
            "form.data.display_registrants": function(val) {
                if(!val){
                    this.form.data.display_payment_status = val;
                    this.form.data.display_selected_activity = val;
                }
            },
            "form.data.enable_submit_payment": function(val) {
                if(!val){
                    this.form.data.payment_receipt_mandatory = val;
                }
            },
            "form.data.enable_enrollment_time": function(val) {
                if(val){
                    if(!this.form.data.enrollment_start_date){
                        this.enroll_start_date = getApp.$moment().format('YYYY-MM-DD');
                        this.enroll_start_time = getApp.$moment().format('HH:mm');
                        this.enroll_end_date = this.end_date;
                        this.enroll_end_time = this.end_time;

                        this.update_form_enroll_start_time();
                        this.update_form_enroll_end_time();
                    }
                }else {
                    this.form.data.enrollment_start_date = null;
                    this.form.data.enrollment_end_date = null;
                }
            }
        },
        mounted() {
            let me = this;
            let mapRef = this.$refs.mapRef;
            this.form.form_handling_object = new FormHandling(this, "saveEventForm", false, "#scrollContainer");
            mapRef.$mapPromise.then(() => {
                let autocomplete = new google.maps.places.Autocomplete(
                    (me.$refs.autocomplete.$refs.input),
                    {types: ['geocode']});
                // remove the default placeholder added by google library
                me.$refs.autocomplete.$refs.input.placeholder = "";

                autocomplete.addListener('place_changed', function() {
                    let place = autocomplete.getPlace();
                    if(place.formatted_address){
                        me.form.data.location_text = place.formatted_address;
                        me.form.data.location_lat = place.geometry.location.lat();
                        me.form.data.location_lng = place.geometry.location.lng();
                        me.gmap_center.lat = place.geometry.location.lat();
                        me.gmap_center.lng = place.geometry.location.lng();
                        setTimeout(function(){
                            mapRef.fitBounds(place.geometry.viewport);
                        }, 100);

                    }
                });
            });


        }
    }
</script>

<style>
    .v-form {
        width: 100%;
    }
    .event-images-wrapper .v-avatar {
        width: 65px!important;
    }

    .event-image-preview {
        border-radius: 3px!important;
    }

    .event-attachment-desc {
        padding-left: 15px;
    }

    .event-attachment-subtitle {
        padding-left: 15px;
    }

    .empty-item-wrapper {
        border: 2px dashed #CCC;
        text-align: center;
        padding: 10px;
    }

    .upload-image-wp {
        cursor: pointer;
    }

    .hidden-textarea {
        display: none;
    }

    .v-label.sp-v-label {
        font-size: 0.9em;
        color: #AAA;
    }

    .ql-snow .ql-tooltip {
        z-index: 100;
    }
</style>